const filter = () => {
    return (input) => {
        return input !== 'Long Term' ? input = input + " months" : input;
    };
};
const ɵ0 = filter;
export const ContractDurationFilter = {
    name: 'contractDuration',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=contract-duration.filter.js.map